(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define(['react'], factory) :
  (global.relayout = factory(global.React));
}(this, function (React) { 'use strict';

  React = 'default' in React ? React['default'] : React;

  function classes(name, props, modifiers) {
    for (var _len = arguments.length, extra = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      extra[_key - 3] = arguments[_key];
    }

    var extraClasses = extra.length ? ' ' + extra.join(' ') : '';
    return Object.keys(modifiers).reduce(function (prev, key) {
      if (!props[key]) {
        return prev;
      }
      return prev + ' ' + name + '--' + modifiers[key];
    }, name) + extraClasses;
  }

  function relayoutItemType(props, propName, componentName) {
    var childrenName = 'RelayoutItem';
    var prop = props[propName];
    var error = null;

    React.Children.forEach(prop, function (child) {
      if (child && child.type.name !== childrenName) {
        error = new Error(componentName + ' only accepts children of type "' + childrenName + '".');
      }
    });

    return error;
  }

  var propTypes = {
    gutter: React.PropTypes.bool,
    align: React.PropTypes.oneOf(['left', 'center', 'right']),
    valign: React.PropTypes.oneOf(['top', 'middle', 'bottom', 'stretch']),
    className: React.PropTypes.string,
    children: relayoutItemType
  };

  var defaultProps = {
    gutter: true
  };

  var Relayout = function Relayout(props) {
    var className = classes('relayout', props, {
      gutter: 'gutter',
      align: props.align,
      valign: props.valign
    }, props.className);

    return React.createElement(
      'div',
      { className: className },
      props.children
    );
  };

  Relayout.propTypes = propTypes;
  Relayout.defaultProps = defaultProps;

  /**
   * Used to reset the display property of RelayoutItem's whenever
   * a smaller breakpoint is set to 0
   */
  function resetClasses(name, props) {
    var items = [];
    var order = ['sm', 'md', 'lg', 'xl'];
    var keys = Object.keys(props).filter(function (value) {
      return order.indexOf(value) >= 0;
    }).sort(function (a, b) {
      return order.indexOf(a) > order.indexOf(b);
    });

    keys.reduce(function (prev, key) {
      if (parseInt(props[prev], 10) === 0 && parseInt(props[key], 10) > 0) {
        items.push(name + '--reset@' + key);
      }
      return key;
    }, '');

    return items.join(' ');
  }

  function sizeType(props, propName, componentName) {
    var value = props[propName];
    var parsedValue = parseInt(value, 10);
    var isNumber = typeof parsedValue === 'number';
    if (value === undefined || isNumber && value >= 0 && value <= 12) {
      return null;
    }
    var msg = 'Wrong column size on ' + componentName + ': it should be a number between 0 and 12.';
    return new Error(msg);
  }

  var propTypes$1 = {
    sm: sizeType,
    md: sizeType,
    lg: sizeType,
    xl: sizeType,
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    relative: React.PropTypes.bool
  };

  var defaultProps$1 = {
    sm: 12
  };

  var RelayoutItem = function RelayoutItem(props) {
    var name = 'relayout__item';
    var className = classes(name, props, {
      sm: props.sm,
      md: props.md + '@md',
      lg: props.lg + '@lg',
      xl: props.xl + '@xl',
      relative: 'relative'
    }, resetClasses(name, props), props.className);

    return React.createElement(
      'div',
      { className: className },
      props.children
    );
  };

  RelayoutItem.propTypes = propTypes$1;
  RelayoutItem.defaultProps = defaultProps$1;

  var propTypes$2 = {
    className: React.PropTypes.string,
    from: React.PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    children: React.PropTypes.node
  };

  var defaultProps$2 = {
    from: 'sm'
  };

  var RelayoutWrapper = function RelayoutWrapper(props) {
    var className = classes('relayout-wrapper', props, {
      from: 'from-' + props.from
    }, props.className);

    return React.createElement(
      'div',
      { className: className },
      props.children
    );
  };

  RelayoutWrapper.propTypes = propTypes$2;
  RelayoutWrapper.defaultProps = defaultProps$2;

  var index = { Relayout: Relayout, RelayoutItem: RelayoutItem, RelayoutWrapper: RelayoutWrapper };

  return index;

}));


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/relayout/lib/index.js
 ** module id = 13
 ** module chunks = 0
 **/